<template>
  <v-autocomplete
    v-bind="$attrs"
    ref="field"
    v-model="localValue"
    :clearable="clearable && !$attrs.readonly && $attrs.readonly !== ''"
    :items="filteredList"
    :loading="loading"
    :readonly="$attrs.readonly"
    @change="(v) => $emit('change', v)"
    @focus="(e) => e.target.click()"
  >
    <template #selection="data">
      <v-chip color="white" :selected="data.selected">
        <v-avatar v-if="data.item.icon">
          <img :src="data.item.icon" />
        </v-avatar>
        {{ data.item.text }}
      </v-chip>
    </template>
    <template #item="data">
      <v-list-tile-avatar v-if="data.item.icon">
        <img :src="data.item.icon" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="data.item.text" />
      </v-list-tile-content>
    </template>
    <template #prepend>
      <v-menu
        v-model="groupMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template #activator="{ on }">
          <v-icon v-on="on"> tune </v-icon>
        </template>

        <v-card>
          <v-layout wrap row>
            <v-flex xs12 px-2>
              <v-select
                v-model="group"
                :items="eventGroups"
                :label="$tc('models.group')"
                clearable
                @change="onChangeGroup"
              />
            </v-flex>
            <v-divider />
          </v-layout>
        </v-card>
      </v-menu>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'TypeEventField',
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
    events: {
      type: Array,
      required: false,
      default: () => [],
    },
    vote: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      itemList: [],
      group: '',
      loading: false,
      groupMenu: false,
    }
  },
  watch: {
    group() {
      if (
        this.value &&
        !this.filteredList.some((item) => item.value == this.value)
      )
        this.$emit('input', '')
    },
    type() {
      if (
        this.value &&
        !this.filteredList.some((item) => item.value == this.value)
      )
        this.$emit('input', '')
    },
  },
  mounted() {
    this.init()
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    filteredList() {
      return this.itemList.filter((item) => {
        let isValid = true
        if (this.type) isValid = item.type && item.type.includes(this.type)
        if (this.group)
          isValid = isValid && item.group && item.group.includes(this.group)
        if (this.vote) isValid = isValid && item.vote
        return isValid && this.isTypeEventIdValid(item.value)
      })
    },

    ...mapState({
      typeEventsConst: (state) => state.typeEvents.typeEventsConst,
    }),
    ...mapGetters({
      eventGroups: 'typeEvents/groups',
    }),
  },
  methods: {
    init() {
      this.loading = true
      this.$store
        .dispatch('typeEvents/fetchSelectList', {})
        .then((list) =>
          list.forEach((item) => {
            this.itemList.push(item)
          })
        )
        .finally(() => {
          this.loading = false
        })
    },
    isTypeEventIdValid(typeEventId) {
      if (
        !this.typeEventsConst ||
        typeof this.typeEventsConst !== 'object' ||
        Object.keys(this.typeEventsConst).length == 0
      )
        return true

      if (typeEventId == this.value) return true

      const {
        ID_START_MATCH,
        ID_END_MATCH,
        ID_START_TRAINING,
        ID_END_TRAINING,
        ID_START_STREAMING,
        ID_END_STREAMING,
        ID_START_REST,
        ID_END_REST,
      } = this.typeEventsConst

      switch (typeEventId) {
        case ID_START_MATCH:
          return !this.typeEventExist(ID_START_MATCH)
        case ID_END_MATCH:
          return (
            !this.typeEventExist(ID_END_MATCH) &&
            this.typeEventExist(ID_START_MATCH)
          )
        case ID_START_TRAINING:
          return !this.typeEventExist(ID_START_TRAINING)
        case ID_END_TRAINING:
          return (
            !this.typeEventExist(ID_END_TRAINING) &&
            this.typeEventExist(ID_START_TRAINING)
          )
        case ID_START_STREAMING:
          return !this.typeEventExist(ID_START_STREAMING)
        case ID_END_STREAMING:
          return (
            !this.typeEventExist(ID_END_STREAMING) &&
            this.typeEventExist(ID_START_STREAMING)
          )
        case ID_START_REST:
        case ID_END_REST:
          // eslint-disable-next-line no-case-declarations
          let startRest = this.typeEventExist(ID_START_REST)
          // eslint-disable-next-line no-case-declarations
          let endRest = this.typeEventExist(ID_END_REST)
          if (typeEventId == ID_START_REST)
            return (startRest + endRest) % 2 == 0
          else return (startRest + endRest) % 2 != 0

        default:
          return true
      }
    },
    typeEventExist(typeEventId) {
      return this.events.filter((event) => event.typeEventId == typeEventId)
        .length
    },
    onChangeGroup() {
      this.groupMenu = false
      this.nextTick(() => this.$refs.field.focus())
    },
  },
}
</script>
